import { render, staticRenderFns } from "./CancelledConfirm.vue?vue&type=template&id=08857770&"
import script from "./CancelledConfirm.vue?vue&type=script&lang=js&"
export * from "./CancelledConfirm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports